import { axios } from 'lib/axios';

export const refreshToken = data => {
  console.log(data);
  return axios.post('/auth/login/refresh/', {
    refresh: data,
  });
};
